<template>
  <div class="wrap1">
    <h1 class="common-title">
      <span> <i class="el-icon-arrow-left back" @click="handlerBack"></i> {{ infoData.title }} </span>
    </h1>
    <div class="wrap1-box wrap1-btn">
      <div class="content-left">
        <el-form ref="form" v-if="query.state !== '4'" :model="formData" :rules="formRules" inline>
          <!-- 工资条模板名称 -->
          <el-form-item v-if="formLabel.name" :label="formLabel.name" prop="name">
            <el-input
              @change.native="e => handlerName(e)"
              v-model="formData.name"
              :placeholder="formLabel.name"
            ></el-input>
          </el-form-item>
          <!-- 结算类型 -->
          <el-form-item v-if="formLabel.type" :label="formLabel.type" prop="type">
            <el-select
              v-model="formData.type"
              value-key="type"
              :placeholder="formLabel.type"
              @change="handlerChangeType"
            >
              <el-option
                v-for="(item, index) in selectData.type_list"
                :key="index"
                :label="item.txt"
                :value="item.type"
              ></el-option>
            </el-select>
          </el-form-item>
          <!-- 税 -->
          <el-form-item
            v-if="formLabel.tax_deduction_status"
            :label="formLabel.tax_deduction_status"
            prop="tax_deduction_status"
          >
            <el-select
              v-model="formData.tax_deduction_status"
              value-key="tax_deduction_status"
              :placeholder="formLabel.tax_deduction_status"
              @change="handlerChangeType"
            >
              <el-option
                v-for="(item, index) in selectData.tax_list"
                :key="index"
                :label="item.txt"
                :value="item.type"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <!-- 查看设置不能修改内容 -->
        <div v-else class="content-left-info">
          <p class="content-left-title">{{ $t('pay_slip_14') }}</p>
          <ul>
            <!-- 工资条名称 -->
            <li>
              <label>{{ $t('1418') }}: </label>
              <span>{{ formData.name }}</span>
            </li>
            <!-- 发送路径 -->
            <li>
              <label>{{ $t('pay_slip_17') }}: </label>
              <span>
                <template v-if="!Number(formData.status) && Number(formData.send_way_app)">{{ $t('App') }}</template>
                <template v-if="Number(formData.status) === 1">{{ $t('pay_slip_33') }}</template>
                <template v-if="Number(formData.status) === 2">{{ $t('pay_slip_34') }}</template>
                <template v-if="Number(formData.send_way_email)">
                  <template v-if="Number(formData.send_way_app) || Number(formData.status)">、</template>
                  {{ $t('personal_email') }}
                </template>
                <template v-if="Number(formData.send_way_exmail)">
                  <template
                    v-if="Number(formData.send_way_app) || Number(formData.status) || Number(formData.send_way_email)"
                    >、</template
                  >
                  {{ $t('business_mailbox') }}
                </template>
              </span>
            </li>
            <li>
              <!-- 是否覆盖 0 否 1 是 -->
              <label>{{ $t('pay_slip_16') }}: </label>
              <span>{{ Number(formData.is_cover_last) ? $t('532') : $t('1626') }}</span>
            </li>
            <li>
              <!-- 0 立即发送 1定时 -->
              <label>{{ $t('pay_slip_15') }}: </label>
              <span>{{ Number(formData.send_time_type) ? $t('1056') : $t('pay_slip_35') }}</span>
            </li>
            <!-- 创建人 -->
            <li>
              <label>{{ $t('create_name') }}: </label>
              <span>{{ formData.created_name }}</span>
            </li>
            <!-- 发送时间, 创建时间 -->
            <li>
              <label>{{ $t('create_at') }} </label>
              <span>{{ formData.created_at || '--' }}</span>
            </li>
            <li>
              <label>{{ $t('206') }}: </label>
              <span>{{ formData.send_time || formData.created_at }}</span>
            </li>
          </ul>
        </div>
        <!-- 创建工资条:1 和 编辑模板:2展示【编辑显示的薪资项】 其他展示 【薪资项】-->
        <p class="content-left-title">
          <span>{{ ['1', '2'].includes(query.state) ? $t('pay_slip_6') : $t('pay_slip_13') }}</span>
          <span v-show="query.state === '3'" @click="visible = true"
            >{{ $t('pay_slip_29') }} <i class="el-icon-sort"></i>
          </span>
        </p>
        <div class="wrap1-tip" v-show="schemeItem.name">
          <i class="el-icon-info icon-info"></i>
          <p>{{ $t('pay_slip_28', { key: schemeItem.name }) }}</p>
        </div>
        <div class="content-left-collapse">
          <div class="collapse-item" v-for="(item, index) in payList" :key="item.txt + '-' + index">
            <div
              class="collapse-item-title"
              :draggable="islist"
              @dragstart="e => handlerDragstart(e, index, 'columns', payList)"
              @dragover.prevent
              @drop="e => handlerDrop(e, index, payList, 'columns', 'show')"
              @dragend="e => handlerDragend(payList, 'columns')"
            >
              <span>
                <i
                  :class="{
                    icon: true,
                    'el-collapse-item__arrow': true,
                    'el-icon-arrow-right': true,
                    active: item.show
                  }"
                  @click="onShow(item)"
                />
                <el-checkbox
                  :indeterminate="item.isIndeterminate"
                  :disabled="['4'].includes(query.state)"
                  v-model="item.is_selected"
                  @change="e => handleCheckAllChange(e, item, index)"
                />
                {{ item.txt }}
              </span>
              <span
                v-show="formLabel.drop"
                class="img"
                @mouseenter="onMouseenter('list')"
                @mouseleave="onMouseleave('list')"
              >
              </span>
            </div>
            <ul :class="{ 'collapse-item-columns': true, show: !item.show }">
              <li
                v-for="(column, cIndex) in item.columns"
                :key="column.txt + '_' + cIndex"
                class="collapse-item-columns-item"
                :draggable="isitem"
                @dragstart="e => handlerDragstart(e, cIndex, 'column')"
                @dragover.prevent.stop
                @drop="e => handlerDrop(e, cIndex, item.columns, 'column')"
                @dragend="e => handlerDragend(item.columns, 'column')"
              >
                <span
                  v-show="formLabel.drop"
                  class="img"
                  @mouseenter="onMouseenter('item')"
                  @mouseleave="onMouseleave('item')"
                ></span>
                <el-checkbox
                  :disabled="['4'].includes(query.state)"
                  v-model="column.is_selected"
                  @change="e => handleCheckChange(item, column)"
                />
                <span class="txt">{{ column.txt }}</span>
              </li>
            </ul>
          </div>
        </div>
        <!-- PDF预览 -->
        <el-button v-if="isUpdate && Number(schemeItem.scheme_id)" size="small" @click="handleUpdate">{{
          $t('pay_slip_49')
        }}</el-button>
      </div>
      <div class="content-right">
        <!-- 预览 -->
        <preview :title="formData.name">
          <!-- 列表循环 -->
          <li class="preview-list" v-for="(item, index) in payList" :key="index">
            <template v-if="item.isIndeterminate || item.is_selected">
              <!-- 父类 -->
              <div class="preview-label">{{ item.txt }}</div>
              <!-- 子类 -->
              <ul class="preview-son">
                <template v-for="(el, i) in item.columns">
                  <li :key="i" v-if="el.is_selected">
                    <span>{{ el.txt }}</span>
                    <span>- -</span>
                  </li>
                </template>
              </ul>
            </template>
          </li>
        </preview>
      </div>
    </div>
    <div class="flex-btn">
      <!-- PDF预览 -->
      <el-button v-if="infoData.button.pdfView" size="small" @click="pdfView" :loading="pdfLoading">{{
        infoData.button.pdfView
      }}</el-button>
      <!-- 保存工资条模板 -->
      <el-button
        v-if="infoData.button.savePaysilp"
        size="small"
        type="primary"
        :loading="saveLoading"
        @click="savePaysilp"
        >{{ infoData.button.savePaysilp }}</el-button
      >
      <!-- 发送 -->
      <el-button v-if="infoData.button.sendPaysilp" size="small" type="primary" @click="sendPaysilp">{{
        infoData.button.sendPaysilp
      }}</el-button>
    </div>
    <!-- 待发工资条-> 发送工资条-> 选择工资条模板 -->
    <el-dialog
      v-if="visible"
      width="648px"
      append-to-body
      :title="$t('pay_slip_1')"
      :visible.sync="visible"
      @close="confirmScheme(false)"
    >
      <div class="scheme" v-for="(item, index) in schemeList" :key="item.payroll_scheme_id">
        <el-radio v-model="schemeIndex" :label="index">{{ item.name }}</el-radio>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" class="edit" type="text" @click="goToDetail" icon="el-icon-plus">{{
          $t('pay_slip_4')
        }}</el-button>
        <el-button size="small" @click="confirmScheme(false)">{{ $t('66') }}</el-button>
        <el-button size="small" type="primary" @click="confirmScheme(true)">{{ $t('131') }}</el-button>
      </span>
    </el-dialog>
    <!-- 确认发送选择发送方式 -->
    <el-dialog
      width="648px"
      v-if="visible1"
      append-to-body
      :title="$t('pay_slip_40')"
      :visible.sync="visible1"
      :before-close="closeSend"
    >
      <el-form ref="sendForm" hide-required-asterisk label-width="150px" :model="formData" :rules="formRules">
        <!-- 发送方式 -->
        <el-form-item v-if="formLabel.send_way" :label="formLabel.send_way" prop="send_way">
          <el-checkbox-group v-model="formData.send_way">
            <el-checkbox label="0">{{ $t('App') }}</el-checkbox>
            <el-checkbox label="1">{{ $t('personal_email') }}</el-checkbox>
            <el-checkbox label="2">{{ $t('business_mailbox') }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <!-- 是否覆盖上一次App工资条 -->
        <el-form-item v-if="formData.is_cover && formData.send_way.includes('0')">
          <el-checkbox v-model="formData.status">{{ $t('pay_slip_41') }}</el-checkbox>
        </el-form-item>
        <!-- 发送时间 -->
        <el-form-item v-if="formLabel.send_time_type" :label="formLabel.send_time_type" prop="send_time_type">
          <el-radio-group v-model="formData.send_time_type">
            <el-radio label="0">{{ $t('pay_slip_35') }}</el-radio>
            <el-radio label="1">{{ $t('1056') }}</el-radio>
          </el-radio-group>
          <el-form-item v-if="formData.send_time_type === '1'" prop="send_time">
            <el-date-picker
              popper-class="send-time"
              v-model="formData.send_time"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetime"
              size="small"
              :picker-options="pickerOptions"
              :placeholder="$t('pay_slip_42')"
            >
            </el-date-picker>
          </el-form-item>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeSend">{{ $t('66') }}</el-button>
        <el-button size="small" type="primary" :loading="sendLoading" @click="confirmSend">{{ $t('131') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import moment from 'moment'
import {
  previewSchemePdf, // 验证工资条姓名是否可用
  getTypeAndTaxList, // 获取结算类型
  getSchemeListBySubId, // 获取工资条模板list
  getAllColumns, // 无模版id 获取模版详情
  getSchemeInfo, // 有模版id 获取模版详情
  getSendAllColumns, // 获取子项目的 scheme
  addscheme, // 新建工资条模板
  editScheme, // 保存编辑工资条模板
  sendPayslip, // 发送工资条
  sentPayslipSetting // 查看设置工资条
} from '@/api/payroll/pay-slip'
import { infoData } from './config.js'
// App端预览组件
import preview from '@/components/mobile-preview'
export default {
  components: { preview },
  data() {
    return {
      query: { ...this.$route.query },
      params: { ...this.$route.params },
      payrollSchemeId: this.$route.query.payroll_scheme_id,
      infoData: infoData[this.$route.query.state],
      formData: infoData[this.$route.query.state].formData,
      formRules: infoData[this.$route.query.state].formRules,
      formLabel: infoData[this.$route.query.state].formLabel,
      selectData: {},
      payList: [], // 自定义方案列表
      cPayList: [], // 自定义方案列表
      schemeList: [],
      visible: +this.$route.query.state === 3,
      visible1: false,
      islist: false,
      isitem: false,
      pdfLoading: false,
      saveLoading: false,
      sendLoading: false,
      isUpdate: false,
      payShow: '',
      schemeIndex: -1,
      cSchemeIndex: 0,
      schemeItem: '',
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() + 3600 * 1000 * 24 * 10 || time.getTime() < Date.now() - 3600 * 1000 * 24
        }
      }
    }
  },
  created() {
    this.getRouterParams()
    // 结算类型列表
    if (['1', '2'].includes(this.query.state)) this.getTypeAndTaxList()
  },
  watch: {
    'formData.send_time': {
      deep: true,
      handler(newValue, oldValue) {
        if (newValue && this.query.state === '3') {
          const time = new Date(newValue).getTime()
          const date = new Date().getTime() + 60 * 1000 * 30
          const nowDate = moment(date).format('yyyy-MM-DD HH:mm:ss')
          const dt = nowDate.split(' ')
          let st = ''
          if (newValue.split(' ')[0] === dt[0] && time < date) {
            // 是今天,选择 的时间开始为此刻的时分秒
            st = dt[1]
          } else if (newValue.split(' ')[0] !== oldValue.split(' ')[0]) {
            // 明天及以后从0时开始
            st = '00:00:00'
          } else {
            st = newValue.split(' ')[1]
          }
          this.formData.send_time = newValue.split(' ')[0] + ' ' + st
        }
      }
    }
  },
  methods: {
    handlerBack() {
      const query = { active: this.query.active }
      if (this.query.month2) query.month2 = this.query.month2
      if (this.query.month3) query.month3 = this.query.month3
      this.$router.push({
        path: '/payroll/pay-slip',
        query
      })
    },
    getRouterParams() {
      // 路由参数获取
      // scheme_id：工资条id  subProjectId：子项目id
      const { schemeId, subProjectId } = this.params
      const { type, tax_deduction_status } = this.query
      this.formData.name = ''
      this.formData.type = Number(type) || ''
      this.formData.tax_deduction_status = Number(tax_deduction_status) || ''
      // 待发工资条-->去发工资条-->创建模板
      if (+this.query.state === 1) this.handlerChangeType()
      else if (+this.query.state === 2) this.handlerGetSchemeInfo(schemeId)
      else if (+this.query.state === 3) {
        this.formData.send_way = []
        this.formData.send_time_type = ''
        this.formData.send_time = ''
        this.formData.status = ''
        this.formData.is_cover = false
        this.getSchemeListBySubId(subProjectId)
      } else if (this.query.state === '4') this.sentPayslipSetting(subProjectId)
    },
    sentPayslipSetting(id) {
      // state:4 编辑工资条模板调用详情数据
      sentPayslipSetting({ payslip_id: id }).then(res => {
        if (res && res.code === 1) {
          this.formData = res.data
          this.formData.type = this.query.type
          this.formData.tax_deduction_status = this.query.tax_deduction_status
          this.handleDetail(res.data.scheme)
        }
      })
    },
    confirmScheme(state) {
      // state:3 确认工资条选择模版 取消关闭弹窗则默认不使用模板
      if (state) {
        this.schemeIndex = this.schemeIndex === -1 ? this.cSchemeIndex : this.schemeIndex
        this.cSchemeIndex = this.schemeIndex
        this.isUpdate = false // 修改模板 更新模板不展示
      } else this.schemeIndex = this.cSchemeIndex
      this.schemeItem = this.schemeList[this.schemeIndex]
      this.visible = false
      getSendAllColumns({
        is_batch: this.$route.query.merge ? '1' : '',
        sub_project_id: this.params.subProjectId,
        scheme_id: this.schemeItem.scheme_id
      }).then(res => {
        if (res && res.code === 1) {
          this.formData.is_cover = res.data.is_cover
          this.handleDetail(res.data.scheme)
        }
      })
    },
    handlerGetSchemeInfo(id) {
      //  state:2 编辑工资条模板调用详情数据
      this.formData.payslip_scheme_id = id
      getSchemeInfo({ payslip_scheme_id: id }).then(res => {
        if (res && res.code === 1) {
          this.formData.type = this.query.state !== '3' ? Number(res.data.settlement_type) : '' // 结算类型
          this.formData.name = this.query.state !== '3' ? res.data.name : '' // 工资条名称
          this.formData.tax_deduction_status = this.query.state !== '3' ? Number(res.data.tax_deduction_status) : '' // 税
          this.handleDetail(res.data.items)
        }
      })
    },
    async handlerChangeType() {
      //  state:1 创建时无ID，获取结算类型关联展示项
      this.payList = []
      const { type, tax_deduction_status } = this.formData
      const params = {
        settlement_type: type,
        tax_deduction_status: tax_deduction_status
      }
      if (!(params.settlement_type && params.tax_deduction_status)) return
      const res = await getAllColumns(params)
      if (res && res.code === 1) {
        this.handleDetail(res.data)
      }
    },
    // 处理获取的详情数据
    handleDetail(data = {}) {
      let payList = []
      const keys = Object.keys(data || {})
      if (keys.length === 0) {
        this.payList = payList
        return
      }
      keys.forEach((item, index) => {
        data[item].is_selected = !!data[item].is_selected
        if (data[item].columns) {
          // columns中的复选框状态
          data[item].columns.forEach(column => {
            column.is_selected = !!column.is_selected
          })
        }
        payList[data[item].sort] = {
          column: data[item].column,
          is_selected: data[item].is_selected,
          sort: data[item].sort,
          txt: data[item].txt,
          isIndeterminate: false,
          key: item,
          show: false,
          columns: data[item].columns
        }
        // 判断复选框状态
        if (payList[index]) {
          if (data[item].columns) {
            payList[index].isIndeterminate = data[item].columns.some(column => column.is_selected)
          }
          if (payList[index].is_selected) payList[index].isIndeterminate = false
        }
      })
      payList = payList.filter(item => item)
      this.payList = payList
    },
    goToDetail() {
      // 创建工资条模板
      this.$router.push({
        path: '/payroll/edit-pay-slip',
        query: { ...this.query, state: 1 }
      })
    },
    async handlerName(e) {
      e.target.value = String(e.target.value).trim()
    },
    // 是否展示薪资项
    onShow(value) {
      if (!value.show) {
        this.payList.forEach(item => {
          item.show = false
        })
      }
      value.show = !value.show
    },
    // 全选
    handleCheckAllChange(val, item) {
      item.isIndeterminate = false
      if (item.columns) {
        item.columns.forEach(column => {
          column.is_selected = val
        })
      }
      this.isUpdate = true
    },
    // 点击复选框控制父元素展示
    handleCheckChange(item) {
      const state = item.columns.every(column => column.is_selected)
      const state1 = item.columns.every(column => !column.is_selected)
      item.is_selected = state
      item.isIndeterminate = state ? false : !state1
      this.isUpdate = true
    },
    // 保存工资条模板
    async savePaysilp() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          this.saveLoading = true
          const query = {
            name: this.formData.name,
            settlement_type: this.formData.type,
            tax_deduction_status: this.formData.tax_deduction_status,
            scheme: this.handData(this.payList)
          }
          let res = {}
          if (this.query.payslip_scheme_id) {
            query.payslip_id = this.query.payslip_scheme_id
            res = await editScheme(query)
          } else res = await addscheme(query)
          this.saveLoading = false
          if (res && res.code === 1) {
            this.$message.success(res.message)
            this.handlerBack()
          }
        }
      })
    },
    handleUpdate() {
      // 更新模板
      const state = this.payList.filter(item => item.is_selected || item.isIndeterminate)
      if (!state.length) {
        this.$message.warning(this.$t('pay_slip_54'))
        return
      }
      this.$confirm(this.$t('pay_slip_51'), this.$t('pay_slip_50'), {
        confirmButtonText: this.$t('131'),
        cancelButtonText: this.$t('66'),
        type: 'warning'
      })
        .then(() => {
          const query = {
            name: this.schemeItem.name,
            settlement_type: this.query.type,
            tax_deduction_status: this.query.tax_deduction_status,
            scheme: this.handData(this.payList),
            payslip_id: this.schemeItem.scheme_id
          }
          editScheme(query).then(res => {
            if (res && res.code === 1) this.$message.success(res.message)
          })
        })
        .catch(() => {})
    },
    closeSend() {
      this.visible1 = false
      this.$refs.sendForm.resetFields()
    },
    confirmSend() {
      // 确认发送
      this.$refs.sendForm.validate(valid => {
        if (valid) {
          const query = {
            is_batch: this.$route.query.merge ? '1' : '',
            sub_project_id: this.params.subProjectId,
            name: this.formData.name,
            send_way: this.formData.send_way.join(','),
            send_time_type: this.formData.send_time_type,
            send_time: this.formData.send_time,
            status: this.formData.status ? '1' : '0',
            scheme: this.handData(this.payList),
            scheme_id: this.schemeItem.scheme_id
          }
          this.sendLoading = true
          sendPayslip(query)
            .then(res => {
              if (res && res.code === 1) {
                this.closeSend()
                // 批量发送 跳转到已发工资条
                if (this.$route.query.merge) {
                  this.$router.push({
                    path: '/payroll/pay-slip',
                    query: { active: '3', month3: this.$route.query.month2 }
                  })
                  return
                }
                // 其他跳转结果页面
                this.$router.push({
                  path: '/payroll/pay-send-results/' + res.data.payslip_id,
                  query: { ...this.$route.query }
                })
                this.$message.success(this.$t('pay_slip_53'))
              }
            })
            .finally(() => {
              this.sendLoading = false
            })
        }
      })
    },
    sendPaysilp() {
      // 选择发送方式
      const state = this.payList.filter(item => item.is_selected || item.isIndeterminate)
      if (!state.length) {
        this.$message.warning(this.$t('pay_slip_54'))
        return
      }
      this.$refs.form.validate(valid => {
        if (valid) this.visible1 = true
      })
    },
    async pdfView() {
      // PDF预览
      if (this.$refs.form) {
        this.$refs.form.validate(valid => {
          if (valid) this.handlePdf()
        })
      } else {
        this.handlePdf()
      }
    },
    async handlePdf() {
      this.pdfLoading = true
      const params = {
        name: this.formData.name,
        settlement_type: this.formData.type,
        tax_deduction_status: this.formData.tax_deduction_status,
        scheme: this.handData(this.payList)
      }
      previewSchemePdf(params)
        .then(res => {
          if (res && res.code === 1) window.open(res.data, '_blank')
        })
        .finally(() => {
          this.pdfLoading = false
        })
    },
    async getTypeAndTaxList() {
      // 获取结算类型
      getTypeAndTaxList().then(res => {
        if (res && res.code && res.code === 1) this.selectData = res.data
      })
    },
    handData(data) {
      // 处理最后需要返回后端的数据
      const scheme = {}
      data.forEach(item => {
        const val = JSON.parse(JSON.stringify(item))
        scheme[item.key] = val
        val.is_selected = val.is_selected ? 1 : 0
        delete val.isIndeterminate
        delete val.key
        delete val.show
        if (val.columns) {
          val.columns.forEach(column => {
            column.is_selected = column.is_selected ? 1 : 0
          })
        }
      })
      return scheme
    },
    onMouseenter(val) {
      // 移入可以拖拽
      this['is' + val] = true
    },
    onMouseleave(val) {
      // 移除关闭拖拽
      this['is' + val] = false
    },
    handlerDragstart(event, index, str, data) {
      // 拖拽
      this.payShow = ''
      if (data) this.handle(data)
      event.dataTransfer.setData(str, index)
    },
    handle(data) {
      data.forEach(item => {
        if (item.show) {
          this.payShow = item.key
          item.show = false
        }
      })
    },
    handlerDrop(event, index, data, str, state) {
      // 拖拽
      this.isUpdate = true
      event.preventDefault()
      // 获取被拖拽元素传递的索引
      const targetIndex = Number(event.dataTransfer.getData(str))
      // 更换位置的数据
      if ((this.isitem && str === 'column') || (this.islist && str === 'columns')) {
        const coverData = data.splice(targetIndex, 1)[0]
        if (state && this.showIdnex !== -1) coverData.show = true
        data.splice(index, 0, coverData)
      }
    },
    handlerDragend(data, type) {
      // 拖拽
      data.forEach((item, index) => {
        item.sort = index
        if (type === 'columns') item.show = item.key === this.payShow
      })
    },
    async getSchemeListBySubId(subProjectId) {
      // 工资条列表
      const res = await getSchemeListBySubId({
        sub_project_id: subProjectId,
        is_batch: this.$route.query.merge ? '1' : ''
      })
      if (res && res.code === 1) {
        res.data.push({
          scheme_id: '0',
          name: this.$t('pay_slip_37'),
          name_key: ''
        })
        this.schemeList = res.data
        this.cSchemeIndex = this.schemeList.length - 1
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.wrap1-box {
  display: flex;
}
.content {
  &-left {
    background: #f7f8f9;
    width: 488px;
    padding: 24px;
    box-sizing: border-box;
    overflow-y: auto;
    &-collapse {
      margin: 12px 0;
      background: #fff;

      .collapse-item {
        .collapse-item-title {
          height: 44px;
          line-height: 44px;
          font-size: 14px;
          font-weight: 500;
          color: rgba(0, 0, 0, 0.85);
          padding-left: 42px;
          border-bottom: 1px solid #f0f0f0;
          display: flex;
          justify-content: space-between;
          align-items: center;
          position: relative;
          .img {
            display: block;
            width: 16px;
            height: 16px;
            background-size: 100%;
            background-image: url('~@/assets/img/icon-drag.png');
            margin: 0 8px 0 auto;
            cursor: pointer;
            &:hover {
              cursor: pointer;
              background-image: url('~@/assets/img/icon-drag-active.png');
            }
          }
          .icon {
            height: 44px;
            width: 16px;
            line-height: 44px;
            color: #bfbfbf;
            text-align: center;
            font-size: 16px;
            position: absolute;
            left: 12px;
            cursor: pointer;
            &.active {
              transform: rotate(90deg);
            }
          }
        }
        .collapse-item-columns {
          background: #f7f8f9;
          &.show {
            position: absolute;
            left: -1000px;
            opacity: 0;
          }
          &-item {
            font-size: 13px;
            color: #303133;
            padding: 0 24px;
            padding-left: 48px;
            height: 46px;
            line-height: 46px;
            user-select: none;
            position: relative;
            display: flex;
            align-content: center;
            flex-wrap: wrap;
            .img {
              position: absolute;
              left: 24px;
              top: 15px;
              display: inline-block;
              vertical-align: middle;
              background-image: url('~@/assets/img/icon-drag1.png');
              &:hover {
                background-image: url('~@/assets/img/icon-drag1-active.png');
              }
            }
            .el-checkbox {
              margin-right: 16px;
            }
            .txt {
              width: 308px;
              white-space: nowrap;
              word-break: break-all;
              text-overflow: ellipsis;
              overflow: hidden;
            }
          }
        }
      }
      /deep/ .el-collapse-item {
        position: relative;
        .el-collapse-item__header {
          .el-icon-arrow-right {
            position: absolute;
            left: 16px;
            color: #bfbfbf;
          }
          .header {
            width: 100%;
            height: 100%;
            padding: 0px 16px 0 42px;
            position: relative;
            display: flex;
            align-items: center;
            .el-checkbox {
              margin-right: 16px;
            }
          }
        }
        .el-collapse-item__content {
          padding: 0;
        }
      }
      .img {
        width: 16px;
        height: 16px;
        background-size: 100%;
        background-image: url('~@/assets/img/icon-drag.png');
        margin: 0 8px 0 auto;
        &:hover {
          cursor: pointer;
          background-image: url('~@/assets/img/icon-drag-active.png');
        }
      }
      .columns {
        background: #f7f8f9;
        &-item {
          padding: 0 24px;
          height: 46px;
          line-height: 46px;
          user-select: none;
          .img {
            display: inline-block;
            vertical-align: middle;
            background-image: url('~@/assets/img/icon-drag1.png');
          }
          &:hover {
            cursor: pointer;
            .img {
              background-image: url('~@/assets/img/icon-drag1-active.png');
            }
          }
          .el-checkbox {
            margin-right: 16px;
          }
        }
      }
    }
    &-title {
      padding-bottom: 10px;
      font-size: 14px;
      color: #262626;
      padding-bottom: 12px;
      display: flex;
      justify-content: space-between;
      span {
        &:last-child {
          height: 20px;
          line-height: 20px;
          cursor: pointer;
          border: 1px solid #d9d9d9;
          border-radius: 4px;
          padding: 0 8px;
          font-size: 14px;
          color: #262626;
          .el-icon-sort {
            transform: rotate(90deg);
            color: #707070;
          }
        }
      }
    }
    &-info {
      padding-bottom: 24px;
      ul {
        padding: 16px;
        background: #fff;
        font-size: 14px;
        color: #606266;
        li {
          margin-bottom: 8px;
          display: flex;
          label {
            line-height: 22px;
            padding-right: 10px;
          }
          span {
            color: #909399;
            flex: 1;
            line-height: 22px;
          }
        }
      }
    }

    .el-form {
      /deep/ .el-form-item {
        width: 100%;
        margin-right: 0;
        .el-form-item__label {
          text-align: left;
          width: 100%;
          padding-left: 20px;
          &::before {
            left: 6px;
          }
          display: block;
        }
        .el-form-item__content {
          width: 100%;
        }
      }
      .button {
        float: right;
      }
    }
    .el-input {
      max-width: 100%;
    }
    .el-select {
      width: 100%;
      /deep/ .el-input {
        max-width: 100%;
      }
    }
  }
  &-right {
    flex: 1;
    overflow-y: auto;
    padding: 0 24px;
    box-sizing: border-box;
    .preview-list {
      .preview-label {
        padding: 0 16px;
        height: 44px;
        line-height: 44px;
        color: #8c8c8c;
      }
      .preview-son {
        background: #fff;
        padding: 0 16px;
        li {
          height: 44px;
          line-height: 44px;
          font-size: 14px;
          color: #595959;
          border-bottom: 1px solid #f0f0f0;
          span {
            &:first-child {
              display: inline-block;
              width: 240px;
              overflow: hidden;
              word-break: break-all;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
            }
            &:last-child {
              width: 18px;
              float: right;
            }
          }
        }
      }
    }
  }
}
.scheme {
  margin-bottom: 12px;
}
.edit {
  float: left;
}
</style>
<style lang="scss">
.send-time {
  .el-button--text {
    display: none;
  }
}
</style>
